// extracted by mini-css-extract-plugin
export default {"nav-button":"Navbar_nav-button__2zSDh"};